import { Application, Controller } from "stimulus"

export default class AddTourImagesController extends Controller {
  
  static targets = ["observableContainer"]
  static values = {imageUrls: Array}

  observer = this.intersectionObserver();
  globalCount = 0;

  connect() {
    this.appendImage();
  }

  intersectionObserver() {
    return new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.2) {
          this.appendImage();
          this.observer.unobserve(entry.target);
        } 
      });
    }, { threshold: 0.25 });
  }

  appendImage() {
    if (this.globalCount <= this.imageUrlsValue.length - 1) {
      const img = this.image();
      this.observer.observe(img);
      this.observableContainerTarget.appendChild(img);
      this.globalCount++;
    }
  }

  image() {
    const imageUrl = this.imageUrlsValue[this.globalCount];
    let img = new Image();
    img.src = imageUrl;
    img.dataset.src = imageUrl;
    img.className = "tour-hero-image"
    return img;
  }
}

const application = Application.start()
application.register("add-tour-images", AddTourImagesController)
